/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddEditFolder} from '../bioplanModels';
// @ts-ignore
import type {Folder} from '../bioplanModels';
/**
 * PlanningFoldersApi - axios parameter creator
 * @export
 */
export const PlanningFoldersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete folder by its identifier
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersFolderIdDelete: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersFolderIdDelete', 'folderId', folderId);
      const localVarPath = `/folders/{folderId}`.replace(`{${'folderId'}}`, encodeURIComponent(String(folderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Edit folder
     * @param {string} folderId
     * @param {AddEditFolder} addEditFolder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersFolderIdPut: async (
      folderId: string,
      addEditFolder: AddEditFolder,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'folderId' is not null or undefined
      assertParamExists('foldersFolderIdPut', 'folderId', folderId);
      // verify required parameter 'addEditFolder' is not null or undefined
      assertParamExists('foldersFolderIdPut', 'addEditFolder', addEditFolder);
      const localVarPath = `/folders/{folderId}`.replace(`{${'folderId'}}`, encodeURIComponent(String(folderId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addEditFolder, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all folders, filtered by for users tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/folders/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create folder
     * @param {AddEditFolder} addEditFolder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersPost: async (addEditFolder: AddEditFolder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'addEditFolder' is not null or undefined
      assertParamExists('foldersPost', 'addEditFolder', addEditFolder);
      const localVarPath = `/folders/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addEditFolder, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningFoldersApi - functional programming interface
 * @export
 */
export const PlanningFoldersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningFoldersApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete folder by its identifier
     * @param {string} folderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersFolderIdDelete(
      folderId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersFolderIdDelete(folderId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFoldersApi.foldersFolderIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Edit folder
     * @param {string} folderId
     * @param {AddEditFolder} addEditFolder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersFolderIdPut(
      folderId: string,
      addEditFolder: AddEditFolder,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersFolderIdPut(folderId, addEditFolder, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFoldersApi.foldersFolderIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all folders, filtered by for users tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Folder>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFoldersApi.foldersGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create folder
     * @param {AddEditFolder} addEditFolder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foldersPost(
      addEditFolder: AddEditFolder,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Folder>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foldersPost(addEditFolder, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFoldersApi.foldersPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningFoldersApi - factory interface
 * @export
 */
export const PlanningFoldersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningFoldersApiFp(configuration);
  return {
    /**
     *
     * @summary Delete folder by its identifier
     * @param {PlanningFoldersApiFoldersFolderIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersFolderIdDelete(
      requestParameters: PlanningFoldersApiFoldersFolderIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .foldersFolderIdDelete(requestParameters.folderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Edit folder
     * @param {PlanningFoldersApiFoldersFolderIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersFolderIdPut(
      requestParameters: PlanningFoldersApiFoldersFolderIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersFolderIdPut(requestParameters.folderId, requestParameters.addEditFolder, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all folders, filtered by for users tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Folder>> {
      return localVarFp.foldersGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create folder
     * @param {PlanningFoldersApiFoldersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foldersPost(
      requestParameters: PlanningFoldersApiFoldersPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Folder> {
      return localVarFp
        .foldersPost(requestParameters.addEditFolder, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for foldersFolderIdDelete operation in PlanningFoldersApi.
 * @export
 * @interface PlanningFoldersApiFoldersFolderIdDeleteRequest
 */
export interface PlanningFoldersApiFoldersFolderIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFoldersApiFoldersFolderIdDelete
   */
  readonly folderId: string;
}

/**
 * Request parameters for foldersFolderIdPut operation in PlanningFoldersApi.
 * @export
 * @interface PlanningFoldersApiFoldersFolderIdPutRequest
 */
export interface PlanningFoldersApiFoldersFolderIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFoldersApiFoldersFolderIdPut
   */
  readonly folderId: string;

  /**
   *
   * @type {AddEditFolder}
   * @memberof PlanningFoldersApiFoldersFolderIdPut
   */
  readonly addEditFolder: AddEditFolder;
}

/**
 * Request parameters for foldersPost operation in PlanningFoldersApi.
 * @export
 * @interface PlanningFoldersApiFoldersPostRequest
 */
export interface PlanningFoldersApiFoldersPostRequest {
  /**
   *
   * @type {AddEditFolder}
   * @memberof PlanningFoldersApiFoldersPost
   */
  readonly addEditFolder: AddEditFolder;
}

/**
 * PlanningFoldersApi - object-oriented interface
 * @export
 * @class PlanningFoldersApi
 * @extends {BaseAPI}
 */
export class PlanningFoldersApi extends BaseAPI {
  /**
   *
   * @summary Delete folder by its identifier
   * @param {PlanningFoldersApiFoldersFolderIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFoldersApi
   */
  public foldersFolderIdDelete(
    requestParameters: PlanningFoldersApiFoldersFolderIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFoldersApiFp(this.configuration)
      .foldersFolderIdDelete(requestParameters.folderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Edit folder
   * @param {PlanningFoldersApiFoldersFolderIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFoldersApi
   */
  public foldersFolderIdPut(
    requestParameters: PlanningFoldersApiFoldersFolderIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFoldersApiFp(this.configuration)
      .foldersFolderIdPut(requestParameters.folderId, requestParameters.addEditFolder, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all folders, filtered by for users tenant ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFoldersApi
   */
  public foldersGet(options?: RawAxiosRequestConfig) {
    return PlanningFoldersApiFp(this.configuration)
      .foldersGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create folder
   * @param {PlanningFoldersApiFoldersPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFoldersApi
   */
  public foldersPost(requestParameters: PlanningFoldersApiFoldersPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningFoldersApiFp(this.configuration)
      .foldersPost(requestParameters.addEditFolder, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
